import { ReactComponent as UserRestrictedContentImage } from "../../../../assets/UserRestrictedContent.svg";
import { Translate, TranslateHtml } from "../../../Translation/Translate";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import { GenericContentRestricted } from "../../shared/GenericContentRestricted";

export default function ContentRestricted() {
  return (
    <GenericContentRestricted
      image={<UserRestrictedContentImage />}
      title={
        <Translate
          translationKey={TranslationKeys.PROFILE_CONTENT_RESTRICTED_TITLE}
        />
      }
      subtitle={
        <TranslateHtml
          translationKey={TranslationKeys.PROFILE_CONTENT_RESTRICTED_SUBTITLE}
        />
      }
    />
  );
}
